import styled from "styled-components";
import { NAVS } from "appLauncher";

const NavBarWrapper = styled.div`
  width: 100%;
  padding: 0 20px;
  height: 72px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.04);
  display: flex;
  align-items: center;
  position: relative;
  left: 50%;
  right: 50%;
  margin-left: -50vw;
  margin-right: -50vw;
  z-index: 10;
`;

const NavBarInner = styled.div`
  max-width: 800px;
  margin: 0 auto;
  width: 100%;
  display: flex;
  align-items: center;
  height: 100%;
  gap: 20px;
  justify-content: center;
`;

const NavItem = styled.button<{ $active: boolean }>`
  min-width: 2em;
  flex: 1;
  background: none;
  border: none;
  outline: none;
  font-size: 18px;
  color: ${({ $active }) => ($active ? "#2640ED" : "#888888")};
  font-weight: ${({ $active }) => ($active ? 700 : 500)};
  cursor: pointer;
  height: 100%;
  position: relative;
  border-bottom: none;
  transition: color 0.2s;
  &::after {
    content: "";
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 0;
    width: ${({ $active }) => ($active ? "50px" : "0")};
    height: 3px;
    background: ${({ $active }) => ($active ? "#2640ED" : "transparent")};
    border-radius: 2px;
    transition: width 0.2s, background 0.2s;
  }
`;

export default function CompanyNavBar() {
  const handleClick = (idx: number) => {
    const navBar = document.getElementById("company-navbar-anchor");
    if (!navBar) return;
    let sibling: Element | null = navBar;
    for (let i = 0; i <= idx; i++) {
      sibling = sibling && sibling.nextElementSibling;
    }
    if (!(sibling instanceof HTMLElement)) return;
    document.getElementById("scroll")?.scrollTo({
      top: sibling.getBoundingClientRect().top + window.scrollY - 72 - 24,
      behavior: "smooth",
    });
  };

  return (
    <NavBarWrapper id="company-navbar-anchor">
      <NavBarInner>
        {NAVS.map(({ name, index }, i) => {
          return (
            <NavItem
              key={name}
              $active={i === 0}
              onClick={() => handleClick(index)}
            >
              {name}
            </NavItem>
          );
        })}
      </NavBarInner>
    </NavBarWrapper>
  );
}
